

export default {
        props: [],
        components: {

        },
        data : function(){       
            return {
            };
        },
        computed: {


            storeLive() {
                return this.$store.getters.getStoreStatus;
            },

            loading() {
                return this.$store.getters.getLoading;
            },
          
        },
        watch:{

            loading(newVal){

                

            }
        },
        created : function(){
            
        },
        mounted : function ()
        {


            //this.getPageData();


        },
        methods:{

        
            
            
        }



    }
